module.exports = __webpack_public_path__ + "img/pay2.018ea801.png";